var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotals(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "23px",
    viewBox: "0 0 20 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_totals",
    transform: "translate(-2.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Totals-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.181818, 1.033451)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5-Copy-3",
    fill: "#FF3F77",
    x: 0,
    y: 9.76672648,
    width: 19.6363636,
    height: 12.2181818
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4-Copy-8",
    fill: "#9D1131",
    transform: "translate(10.442975, 4.974545) scale(1, -1) rotate(-270.000000) translate(-10.442975, -4.974545) ",
    points: "10.5374003 1.56874917e-13 10.5374003 3.31304462 15.3600628 3.31304462 15.3600628 6.64649436 10.5374003 6.64649436 10.5374003 9.94909091 5.52588762 4.97454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1909421,15.3975628 L5.3553719,15.3975628 L5.3553719,14.7133447 L6.62995041,14.7133447 C7.06730579,12.8928356 8.57930579,11.512181 10.6161322,11.512181 C11.8032397,11.512181 12.902876,12.0253447 13.7400992,12.856181 L12.9528595,13.6259265 C12.3030744,13.0027992 11.490843,12.5995992 10.6161322,12.5995992 C9.22909091,12.5995992 8.19193388,13.5159628 7.81705785,14.7133447 L11.1909421,14.7133447 L11.1909421,15.3975628 Z M5.3553719,16.1428719 L11.1909421,16.1428719 L11.1909421,16.8148719 L7.82955372,16.8148719 C8.20442975,17.9878174 9.25408264,18.8797447 10.6161322,18.8797447 C11.490843,18.8797447 12.3155702,18.4765447 12.9653554,17.8411992 L13.752595,18.6231628 C12.9153719,19.4539992 11.8032397,19.9671628 10.6161322,19.9671628 C8.60429752,19.9671628 7.09229752,18.6231628 6.64244628,16.8148719 L5.3553719,16.8148719 L5.3553719,16.1428719 Z",
    id: "\\u20AC-copy-2",
    fill: "#FFFFFF"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotals);
export default __webpack_public_path__ + "static/media/totals.eb603ac560f51c872e7c29ffe2f83a08.svg";
export { ForwardRef as ReactComponent };